/**
 * 对账周期
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ReconciliationModal.module.scss';
import http from '@/assets/api/http';
import { Modal, message, Form, Select, Space } from 'antd';
import { TableActionType as ta } from '@/util/enum';


const layout = {
    labelCol: {
        span: 3
    }
};

const days = [];
for (let i = 1; i < 29; i++)days.push({ value: i, label: i });

const InfoModal = (props) => {

    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();

    const _handleOk = () => {
        form.validateFields().then(fields => {
            setConfirmLoading(true);
            http('/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.handlerEpReconciliation', {
                ...fields,
                id: props.data.id
            }, 'POST').then(() => {
                message.success('提交成功');
                setConfirmLoading(false);
                props.closeMode && props.closeMode(true);
            }).catch((e = {}) => {
                message.success(e.message || '提交异常');
                setConfirmLoading(false)
                props.closeMode && props.closeMode();
            });
        });
    }

    const _handleCancel = () => {
        props.closeMode && props.closeMode();
    }

    useEffect(() => {
        if (props.type === ta.edit) {
            const { ...fields } = props.data;
            form.setFieldsValue({
                ...fields
            });
        }
    });

    return (
        <Modal
            width={520}
            centered
            title={props.title}
            visible={props.visible}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >
            <Form {...layout} className={styles.container} form={form} labelAlign='left'>
                <Form.Item label="每月">
                    <Space>
                        <Form.Item
                            noStyle
                            name="reconciliationDay"
                            rules={[{ required: true, message: '请选择日期' }]}
                        >
                            <Select placeholder='请选择' style={{ width: 100 }} options={days}></Select>
                        </Form.Item>
                        <span>日系统自动生成对账的单</span>
                    </Space>
                </Form.Item>
            </Form>
            <div style={{ color: '#808080', fontSize: 13, paddingLeft: 58 }}>
                <p>每月1个对账单，举例：</p>
                <p>企业1为每月3日生成上月3日0点到本月2日23:59:59的数据；</p>
                <p>企业1为每月26日生成上月26日0点到本月25日23:59:59的数据；</p>
            </div>
        </Modal>
    );

}

InfoModal.propTypes = {
    positionList: PropTypes.array,
    data: PropTypes.object, // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
    type: PropTypes.string,
    curTabID: PropTypes.string,
};

export default InfoModal;